var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.41,
    height: 20.225,
    viewBox: "0 0 15.41 20.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-3-line",
    d: "M19.41,21.225H17.483V19.3a2.889,2.889,0,0,0-2.889-2.889H8.815A2.889,2.889,0,0,0,5.926,19.3v1.926H4V19.3a4.816,4.816,0,0,1,4.815-4.816h5.779A4.816,4.816,0,0,1,19.41,19.3Zm-7.7-8.668a5.779,5.779,0,1,1,5.779-5.779A5.779,5.779,0,0,1,11.7,12.557Zm0-1.926A3.852,3.852,0,1,0,7.852,6.779,3.852,3.852,0,0,0,11.7,10.631Z",
    transform: "translate(-4 -1)",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b013291c4f86c4b98da82a03b0f68240.svg";
export { ForwardRef as ReactComponent };